<template>
    <v-dialog v-model="shown" width="1100px" persistent>
        <v-card>
            <v-card-title
                class="headline"
            >{{isNew ? 'Create' : 'Edit'}} Campaign {{isNew || !model ? '' : model.campaignNumber}}</v-card-title>
            <v-card-text>
                <v-container grid-list-md v-if="model">
                    <v-layout wrap>
                        <v-flex xs6>
                            <v-text-field
                                v-model="model.name"
                                label="Campaign Name"
                                v-validate="'required'"
                                :error-messages="errors.collect('name')"
                                name="name"
                                required
                                :disabled="!userIsFleetManager"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                v-model="model.tsbWpaReference"
                                label="TSB / Reference"
                                :error-messages="errors.collect('reference')"
                                name="reference"
                                :disabled="!userIsFleetManager"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu
                                v-if="userIsFleetManager"
                                v-model="maxDateDialog"
                                max-width="290px"
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="formattedDate"
                                        label="Max Date of Completion?"
                                        readonly
                                        v-validate="'required'"
                                        :error-messages="errors.collect('max date')"
                                        name="max date"
                                        v-on="on"
                                        required
                                        append-icon="event"
                                        @click:append="maxDateDialog = true"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="model.maxCompletionDate"
                                    class="mt-2 mb-3 elevation-0"
                                    :min="minDate"
                                    no-title
                                    @change="maxDateDialog = false; reValidate('max date', formattedDate)"
                                ></v-date-picker>
                            </v-menu>
                            <v-text-field
                                v-else
                                :value="formattedDate"
                                label="Max Date of Completion?"
                                disabled
                                name="max date"
                                append-icon="event"
                                @click:append="maxDateDialog = true"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="title">Find units</v-flex>
                        <v-flex xs6 class="title">Units in Campaign</v-flex>
                        <v-flex xs6 class="vh50">
                            <v-text-field
                                :loading="isSearchingUnit"
                                v-model="search"
                                outlined
                                label="Search Unit Name/Number/Rego/Vin"
                                name="unit"
                                multiple
                                autocomplete="off"
                                clearable
                                class="mr-3"
                            ></v-text-field>
                            <v-list>
                                <v-list-item v-for="unit in filteredUnits" :key="unit.id">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ unit.number }} ({{unit.department}}) - {{ unit.garage }}</v-list-item-title>
                                        <v-list-item-subtitle v-text="unit.name"></v-list-item-subtitle>
                                        <v-list-item-subtitle>VIN: {{ unit.vin }} Rego: {{unit.registrationNumber}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn
                                            @click="selectUnit(unit)"
                                            icon
                                            small
                                            v-if="userIsFleetManager"
                                        >
                                            <v-icon>arrow_right</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                        <v-flex xs6 class="vh50">
                            <v-list>
                                <v-list-item
                                    v-for="unit in sortedUnits"
                                    :key="unit.id"
                                    :class="{'completed': unit.isComplete, 'past-due': unit.isPastDue}"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="d-flex">
                                            <div>{{ unit.unitNumber }} ({{unit.unitDepartment}}) - {{ unit.unitGarageLocation }}</div>
                                            <v-chip
                                                v-if="unit.isPastDue"
                                                class="ml-2"
                                                label
                                                small
                                                color="red"
                                                :dark="true"
                                            >+{{unit.overdueDays}}</v-chip>
                                            <v-spacer></v-spacer>
                                            <div>{{unit.scheduledDate | formatDateShort}}</div>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-text="unit.unitName"></v-list-item-subtitle>
                                        <v-list-item-subtitle>VIN: {{ unit.unitVin }} Rego: {{unit.unitRegistrationNumber}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn
                                            @click="deselectUnit(unit)"
                                            icon
                                            small
                                            v-if="userIsFleetManager && !unit.isComplete"
                                        >
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-menu offset-y v-if="!isNew">
                    <template v-slot:activator="{ on }">
                        <v-btn small tile v-on="on">
                            <v-icon>save_alt</v-icon>&nbsp;Export
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="exportCsv()">
                            <v-list-item-title>
                                <v-icon>grid_on</v-icon>&nbsp;Excel (CSV)
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="submit"
                    :loading="saving"
                    v-if="userIsFleetManager"
                >Save</v-btn>
                <v-btn text @click="shown=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';
import CampaignClient from '@/components/Campaigns/CampaignClient.vue';
import FormValidation from '../FormValidation.vue';
import DownloadHelper from '@/lib/DownloadHelper';
import * as _ from 'lodash';
export default {
    mixins: [CampaignClient, FormValidation],
    data() {
        return {
            model: null,
            shown: false,
            isNew: false,
            saving: false,
            maxDateDialog: false,
            isSearchingUnit: false,
            selectedUnits: null,
            units: [],
            search: '',
            minDate: moment(new Date()).format(DateFormat.Canonical)
        };
    },
    computed: {
        formattedDate() {
            if (!this.model.maxCompletionDate) {
                return '';
            }
            return moment(this.model.maxCompletionDate).format(DateFormat.DefaultDisplay);
        },
        filteredUnits() {
            var units = this.units;
            return units.filter(u => !this.model.units.filter(x => x.unitId == u.id).length);
        },
        sortedUnits() {
            var units = this.model.units;
            return units.sort((a, b) => (a.unitNumber < b.unitNumber ? -1 : 1));
        }
    },
    methods: {
        show(model) {
            this.isNew = false;
            this.shown = true;
            this.model = model;
            this.reset();
        },
        create() {
            this.isNew = true;
            this.shown = true;
            this.model = {
                maxCompletionDate: null,
                name: '',
                tsbWpaReference: '',
                units: []
            };
            this.reset();
        },
        reset() {
            this.search = '';
            this.units = [];
            this.$validator.reset();
            this.saving = false;
        },
        selectUnit(unit) {
            this.model.units.push({
                unitId: unit.id,
                unitDepartment: unit.department,
                unitRegistrationNumber: unit.registrationNumber,
                unitVin: unit.vin,
                unitGarageLocation: unit.garage,
                unitName: unit.name,
                unitNumber: unit.number
            });
        },
        deselectUnit(unit) {
            this.model.units = this.model.units.filter(x => x != unit);
        },
        async submitForm() {
            this.saving = true;
            var model = {
                id: this.model.id || this.$uuid.v1(),
                name: this.model.name,
                tsbWpaReference: this.model.tsbWpaReference,
                unitIds: this.model.units.map(x => x.unitId),
                maxCompletionDate: this.model.maxCompletionDate
            };
            var response = await (this.isNew ? this.addCampaign(model) : this.updateCampaign(model));
            if (response.status >= 200 && response.status < 300) {
                this.shown = false;
            }
            this.saving = false;
        },
        performSearch: _.debounce(async (val, me) => {
            if (!me.search) {
                me.search = '';
            }
            if (!me.search) {
                return;
            }

            try {
                me.isSearchingUnit = true;
                const response = await me.$api.get(`units?searchTerm=${me.search}&unitType='vehicle'&orderByUnitMatch=true&pageSize=1000&page=1`);
                me.units = response.data.data;
            } catch {
                me.$toast.error('There was an error getting units');
            }
            me.isSearchingUnit = false;
        }, 1000),
        exportCsv() {
            var rows = [
                ['Name', this.model.name],
                ['Number', this.model.campaignNumber],
                ['TSB / Reference', this.model.tsbWpaReference],
                ['Due By', moment(this.model.maxCompletionDate).format(DateFormat.DefaultDisplay)],
                [''],
                ['Unit Number', 'Department', 'Garage', 'Name', 'VIN', 'Registration', 'Complete?', 'Completed By', 'Scheduled Date']
            ];

            for (let unit of this.model.units) {
                rows.push([
                  unit.unitNumber,
                  unit.unitDepartment,
                  unit.unitGarageLocation,
                  unit.unitName,
                  unit.unitVin,
                  unit.unitRegistrationNumber,
                  unit.isComplete ? 'Y' : 'N',
                  unit.completedBy,
                  moment(unit.scheduledDate).format(DateFormat.DefaultDisplay)
                ]);
            }

            var csv = DownloadHelper.makeCsv(null, rows);
            DownloadHelper.download(`Campaign_${this.model.campaignNumber}_${moment().format(DateFormat.Canonical)}.csv`, new Blob([csv]));
        }
    },
    watch: {
        async search(val) {
            this.performSearch(val, this);
        }
    }
};
</script>
<style lang="scss">
.vh50 {
    height: 50vh;
    overflow-y: scroll;
}
</style>
